import { render, staticRenderFns } from "./DirectorShiftsContacts.vue?vue&type=template&id=dbbb024a&lang=pug&"
import script from "./DirectorShiftsContacts.vue?vue&type=script&lang=js&"
export * from "./DirectorShiftsContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports